import * as yup from 'yup'

export const schemaSignUp = yup.object().shape({
  email: yup.string().required().email(),
  fullName: yup.string().required(),
})
